import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addStateFavourite } from '../services/statesService';

export function useAddStateFavourite() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addStateFavourite,
    onMutate: async (variables) => {
      const normalizedStateId = Number(variables?.state_id);
      const normalizedStatus = Number(variables?.status);

      await queryClient.cancelQueries({ queryKey: ['states'] });

      const previousStatesData = queryClient.getQueryData(['states']);

      queryClient.setQueryData(['states'], (currentData) => {
        if (!currentData?.states?.length) {
          return currentData;
        }

        return {
          ...currentData,
          states: currentData.states.map((state) =>
            Number(state?.state_id) === normalizedStateId
              ? {
                  ...state,
                  is_favourite: normalizedStatus,
                }
              : state
          ),
        };
      });

      return { previousStatesData };
    },
    onError: (_error, _variables, context) => {
      if (context?.previousStatesData) {
        queryClient.setQueryData(['states'], context.previousStatesData);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['states'] });
    },
  });
}
